import { FC } from 'react';
import { css } from '@emotion/react';
import { colors, spacing, fontStyles } from '../../styles';

type Language = 'en' | 'es';

interface Props {
  selectedLanguage: Language;
  onChange: (language: Language) => void;
}

const languages: { value: Language; label: string }[] = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
];

const LanguageSelector: FC<Props> = ({ selectedLanguage, onChange }) => {
  return (
    <div
      role="radiogroup"
      css={css`
        display: flex;
        flex: 1;
        gap: ${spacing.milli};
        padding: ${spacing.micro};
        background: ${colors.fog};
        border-radius: 12px;
        border: 0.5px solid ${colors.liquorice}20;

        html[data-theme='dark'] & {
          background: rgba(80, 78, 75, 0.3);
          border-color: ${colors.cloud}30;
        }
      `}
    >
      {languages.map((lang) => (
        <button
          key={lang.value}
          role="radio"
          aria-checked={selectedLanguage === lang.value}
          onClick={() => onChange(lang.value)}
          css={css`
            flex: 1;
            padding: ${spacing.centi} ${spacing.deci};
            border: none;
            border-radius: 10px;
            background: ${selectedLanguage === lang.value ? colors.snow : 'transparent'};
            color: ${selectedLanguage === lang.value ? 'var(--text-color)' : colors.silver};
            box-shadow: ${selectedLanguage === lang.value ? '0 1px 3px rgba(0, 0, 0, 0.08)' : 'none'};
            ${fontStyles.mouse};
            font-weight: ${selectedLanguage === lang.value ? 500 : 400};
            cursor: pointer;
            transition: all 0.15s ease;

            &:hover {
              color: var(--text-color);
            }

            html[data-theme='dark'] & {
              background: ${selectedLanguage === lang.value ? colors.liquorice : 'transparent'};
              color: ${selectedLanguage === lang.value ? 'var(--text-color)' : colors.cloud};
            }
          `}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
